"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Base_1 = require("./Base");
var defaults_1 = require("./defaults");
var navigator_1 = require("../../utils/navigator");
var invoke_1 = __importDefault(require("lodash/invoke"));
var LinearProgress_1 = __importDefault(require("@material-ui/core/LinearProgress"));
var layers_1 = require("./layers");
var debounce_1 = __importDefault(require("lodash/debounce"));
var over_1 = __importDefault(require("lodash/over"));
function buildUserMarker() {
    var el = document.createElement('div');
    var el2 = document.createElement('div');
    el2.className = 'mapboxgl-user-location-dot';
    el.appendChild(el2);
    var marker = new window.mapboxgl.Marker(el);
    return marker;
}
function MapboxUser(_a) {
    var _b = _a.options, options = _b === void 0 ? defaults_1.defaultOptions : _b, _c = _a.getInitialCenter, getInitialCenter = _c === void 0 ? navigator_1.getNavigatorLocation : _c, _d = _a.getLayers, getLayers = _d === void 0 ? layers_1.getCenterQuadkeyLayers : _d, props = __rest(_a, ["options", "getInitialCenter", "getLayers"]);
    var unSubscribe = react_1.useRef([]);
    var handleMapLoad = function (map, ev) {
        invoke_1.default(props, 'handleMapLoad', map, ev);
        var layers = getLayers(map, options) || [];
        layers.forEach(function (layer) {
            map.addLayer(layer);
        });
        var marker = buildUserMarker();
        unSubscribe.current.push(navigator_1.watchNavigatorLocation(function (lngLat) {
            invoke_1.default(props, 'handleNavigatorLocation', map, lngLat);
            marker.setLngLat(lngLat);
            marker.addTo(map);
        }));
    };
    var redraw = debounce_1.default(function (map) {
        var layers = getLayers(map, options) || [];
        layers.forEach(function (layer) {
            var source = map.getSource(layer.id);
            if (source)
                source.setData(layer.source.data);
        });
    }, 17);
    var handleMapDrag = function (map, ev) {
        invoke_1.default(props, 'handleMapDrag', map, ev);
        redraw(map);
    };
    var handleMapZoom = function (map, ev) {
        invoke_1.default(props, 'handleMapZoom', map, ev);
        redraw(map);
    };
    var handleMapClick = function (map, ev) {
        invoke_1.default(props, 'handleMapClick', map, ev);
    };
    react_1.useEffect(function () { return function () {
        over_1.default(unSubscribe.current)();
        unSubscribe.current = [];
    }; }, []);
    return (react_1.default.createElement(Base_1.MapboxBase, __assign({ renderLoader: function () { return react_1.default.createElement(LinearProgress_1.default, null); } }, props, { options: options, getInitialCenter: getInitialCenter, handleMapLoad: handleMapLoad, handleMapDrag: handleMapDrag, handleMapZoom: handleMapZoom, handleMapClick: handleMapClick })));
}
exports.MapboxUser = MapboxUser;
//# sourceMappingURL=User.js.map